import Builder from '../../utils/redux/builder';

const builder = new Builder({
  name: 'errorHandler',
  initialState: {
    errors: [],
  },
  reducers: {
    onShowError(state, { payload: error }) {
      const current = state?.errors?.find?.((one) => one?.uid === error?.uid);
      if (current) current.showed = true;
    },
    addError(state, action) {
      addNewError(state, action);
    },
  },
});

function displayErrorFilter(error) {
  return error.code >= 400 && error.code <= 599;
}

builder.createSelector('displayedErrors', function (STATE) {
  return {
    displayErrors: STATE[builder.name].errors.filter((error) => !error.showed).filter(displayErrorFilter),
  };
});

function errorsCondition(type) {
  const exceptions = ['service-data'];

  // Проверка на наличие исключений в type
  for (const exception of exceptions) {
    if (type.includes(exception)) {
      return false;
    }
  }

  // Проверка на наличие "rejected" в type
  if (type.includes('rejected')) {
    return true;
  }

  return false;
}

builder.create();

const errorHandlerReducer = builder.export();
export default errorHandlerReducer;
export const { useDisplayedErrors } = errorHandlerReducer.selectors;

function addNewError(state, action) {
  state.errors.push(DisplayError(action));
  action.uid = state.errors.length;
}

function DisplayError(action) {
  const actionType = action?.type;
  const code = Number(action.payload?.code);
  const name = action.payload?.name;
  const serverDebugLink = action.payload?.headers?.['x-debug-link'];
  const displayMessage = !code ? actionType : serverDebugLink;
  return {
    actionType,
    code,
    serverDebugLink,
    displayMessage,
    name,
  };
}
